<da-single-stage [data]="'error500.singleStage' | translate"></da-single-stage>
<section class="background-color-nearwhite">
    <div class="container">
        <h1 [innerHTML]="'error500.singleStage.title' | translate"></h1>
    </div>
</section>
